module.exports = __webpack_public_path__ + "static/img/home-new6.782a96b5.jpeg";